import LogtoClient from "@logto/browser";
import { runtimeConfig } from "./runtime-config";

/**
 * The single SimpleApp Logto resource indicator and JWT `aud` target.
 */
export const SIMPLEAPP_LOGTO_AUDIENCE = runtimeConfig.logtoAudience;

export const LOGTO_APP_ID = import.meta.env.VITE_LOGTO_APP_ID;

export const hasLogtoAppId =
  typeof LOGTO_APP_ID === "string" && LOGTO_APP_ID.trim().length > 0;

/**
 * Logto SDK client. Target identity comes from runtime config while shared
 * Logto client settings remain build-time values.
 *
 * Shared build-time env vars:
 * - VITE_LOGTO_ENDPOINT: issuer base URL
 * - VITE_LOGTO_APP_ID: dedicated SimpleApp SPA client ID
 */
export const logtoClient = new LogtoClient({
  endpoint: import.meta.env.VITE_LOGTO_ENDPOINT,
  appId: import.meta.env.VITE_LOGTO_APP_ID,
  scopes: ["openid", "profile", "email", "offline_access"],
  resources: [SIMPLEAPP_LOGTO_AUDIENCE],
});
